import { AssetEvent } from './asset.event';
import { EventRegistry } from '../../../../../domain/event/event.registry';
export class LegacyPhotosUnlinkedFromAssetEventV2 extends AssetEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.assetClassId}/asset/${payload.id}`,
            type: LegacyPhotosUnlinkedFromAssetEventV2.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
LegacyPhotosUnlinkedFromAssetEventV2.type = 'com.treeplotter.api.asset.legacyPhotosUnlinkedFromAsset.v2';
EventRegistry.register(LegacyPhotosUnlinkedFromAssetEventV2.type, LegacyPhotosUnlinkedFromAssetEventV2);
//# sourceMappingURL=legacy-photos-unlinked-from-asset-v2.event.js.map